// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"93":"0bafea67","942":"2548dde8","991":"3337f30c"}[chunkId] + ".js";
};